import { shallowEqual, useSelector } from 'react-redux';
import NsContent from 'components/common/ns-content/NsContent';

import { NsAlert } from 'components/common/ns-alert/NsAlert';
import { NsBackCta } from 'components/common/ns-back-cta/NsBackCta';
import { NsTitle } from 'components/common/ns-title/NsTitle';
import { selectedAddress } from 'state/selected-address/selected-address-slice';
import { useMaskPII } from 'hooks/useMaskPII';

export const MeterReadsTop = () => {
  const { mask } = useMaskPII();
  const address = useSelector(selectedAddress, shallowEqual);
  return (
    <>
      <NsBackCta />
      <NsContent>
        <NsTitle title="Please enter any meter readings you took" />
        <p>
          These will be from the day you got the keys. Add numbers before the
          decimal place.
        </p>
        <NsAlert heading="This step is optional" state="info">
          <p>
            If you didn&apos;t take meter readings, please leave this blank and
            we&apos;ll use an estimated reading.
          </p>
        </NsAlert>
        <h2 {...mask}>
          {address?.displayName}, {address?.postcode}
        </h2>
      </NsContent>
    </>
  );
};
